import "core-js/modules/es.array.push.js";
import { onMounted, reactive, toRefs, onActivated } from "vue";
import { Button, Cell, Collapse, CollapseItem, Field, List } from 'vant';
import AppHeader from '@/components-H5/AppHeader.vue';
import apis from "@/api";
import { useRouter } from 'vue-router';
import store from '@/store';
import { ACCESS_TOKEN } from "@/store/mutation-types";
import 'vant/es/field/style';
import 'vant/es/button/style';
import 'vant/es/collapse/style';
import 'vant/es/collapse-item/style';
export default {
  components: {
    AppHeader,
    Field,
    Button,
    Collapse,
    CollapseItem,
    List,
    Cell
  },
  setup() {
    let data = reactive({
      posName: "",
      activeNames: [],
      shops: null
    });
    onActivated(() => {
      // http://xxxx/ds?token=31232231
      let params = router.currentRoute.value.query;
      if (params.token) {
        store.commit("setCruiseShop", {
          token: params.token
        });
        window.localStorage.setItem(ACCESS_TOKEN, params.token);
      }
      search();
    });
    const search = () => {
      apis.getShops(data.posName).then(res => {
        if (res.success) {
          data.shops = res.data;
        }
      });
    };
    const router = useRouter();
    const selectShop = shop => {
      store.commit("setCruiseShop", {
        shopId: shop.id,
        shopName: shop.shopName
      });
      router.push(`/h5/cruiseShop/selectPosition`);
    };
    return {
      ...toRefs(data),
      search,
      selectShop
    };
  }
};